import {  postEmailVerifyOtp } from "../../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_email_verify_otpThunk = createAsyncThunk(
  "reKyc_email_verify_otpThunk",
  async ({ params, token }) => {
    try {
      const response = postEmailVerifyOtp(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
